module.exports = __webpack_public_path__ + "img/DE02248.d6560be3.png";